import { render, staticRenderFns } from "./SegmentToggle.vue?vue&type=template&id=0b2487e0&scoped=true"
import script from "./SegmentToggle.vue?vue&type=script&lang=js"
export * from "./SegmentToggle.vue?vue&type=script&lang=js"
import style0 from "./SegmentToggle.vue?vue&type=style&index=0&id=0b2487e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2487e0",
  null
  
)

export default component.exports